import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_AVAILABILITIES_CREATE } from '../../constants/doctorTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { doctorAvailabilitySchema } from '../../schemas/Normalizr';
import { tooltipHide } from '../../actions/tooltipActions';
import { DOCTOR_AVAILABILITIES_CHANGE_SUCCESS, DOCTOR_AVAILABILITIES_CHANGE_ERROR } from '../../constants/messages';
import { toastr } from 'react-redux-toastr';

export function* doctorAvailabilitiesCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(DOCTOR_AVAILABILITIES_CREATE, call(doctorAPI.availabilitiesCreate, params), doctorAvailabilitySchema);
    yield put(tooltipHide({ id: params.tooltipId }));
    yield toastr.success('success', DOCTOR_AVAILABILITIES_CHANGE_SUCCESS);
  } catch (e) {
    yield toastr.error(DOCTOR_AVAILABILITIES_CHANGE_ERROR);
    yield put(error(DOCTOR_AVAILABILITIES_CREATE, e));
  } finally {
    yield put(doneIndicator(DOCTOR_AVAILABILITIES_CREATE));
  }
}

export function* watchDoctorAvailabilitiesCreate() {
  yield takeEvery(DOCTOR_AVAILABILITIES_CREATE, doctorAvailabilitiesCreate);
}

export default function* root() {
  yield all([
    fork(watchDoctorAvailabilitiesCreate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorAvailabilitiesCreate.js